enum ApplicationVariableSortingField {
  DisplayName = 'displayName',
  Value = 'value',
}

export default ApplicationVariableSortingField;
